import { createContext, useContext, useState, ReactNode } from "react";

interface ClaimrWidgetContextType {
  isInitialized: boolean;
  setInitialized: (initialized: boolean) => void;
}

const ClaimrWidgetContext = createContext<ClaimrWidgetContextType | undefined>(
  undefined
);

export const ClaimrWidgetProvider = ({ children }: { children: ReactNode }) => {
  const [isInitialized, setIsInitialized] = useState(false);

  return (
    //@ts-ignore
    <ClaimrWidgetContext.Provider
      value={{ isInitialized, setInitialized: setIsInitialized }}
    >
      {children}
    </ClaimrWidgetContext.Provider>
  );
};

export const useClaimrWidget = () => {
  const context = useContext(ClaimrWidgetContext);
  if (!context) {
    throw new Error(
      "useClaimrWidget must be used within a ClaimrWidgetProvider"
    );
  }
  return context;
};
